import axios from 'axios';
import { apiURL as baseURL } from '~/config';
import interceptorResponse, { onResponseError } from './interceptorResponse';

const ApiAuthless = axios.create({ baseURL });
ApiAuthless.interceptors.response.use(interceptorResponse, onResponseError);

export default ApiAuthless;
